document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".product-faq").forEach((section) => {
    const items = section.querySelectorAll(".product-faq__item");

    items.forEach((item) => {
      const btn = item.querySelector(".product-faq__question");
      const content = item.querySelector(".product-faq__answer");

      btn.addEventListener("click", () => {
        items.forEach((i) => {
          const c = i.querySelector(".product-faq__answer");

          if (i !== item) {
            i.classList.remove("active");
            c.style.maxHeight = null;
          }
        });

        item.classList.toggle("active");

        if (item.classList.contains("active")) {
          content.style.maxHeight = content.scrollHeight + "px";
        } else {
          content.style.maxHeight = null;
        }
      });
    });
  });
});
